import { Routes, Route } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import DashboardPage from './pages/DashboardPage';
import InvoiceListPage from './pages/InvoiceListPage';
import AnalyticsPage from './pages/AnalyticsPage';
import UploadPage from './pages/UploadPage';
import InvoiceResultPage from './pages/InvoiceResultPage';
import InvoiceIssuesPage from './pages/InvoiceIssuesPage';
import InvoiceEditPage from './pages/InvoiceEditPage';
import McpSetupPage from './pages/McpSetupPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { PeriodFilterProvider } from './context/PeriodFilterContext';

function App() {
  return (
    <ErrorBoundary>
      <PeriodFilterProvider>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/invoices" element={<InvoiceListPage />} />
            <Route path="/invoices/:id" element={<InvoiceResultPage />} />
            <Route path="/invoices/:id/issues" element={<InvoiceIssuesPage />} />
            <Route path="/invoices/:id/edit" element={<InvoiceEditPage />} />
            <Route path="/invoices/edit" element={<InvoiceEditPage />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/mcp" element={<McpSetupPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </PeriodFilterProvider>
    </ErrorBoundary>
  );
}

export default App;
